import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/stackpath': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M244.6 232.4c0 8.5-4.3 20.5-21.3 20.5h-19.6v-41.5h19.6c17.1 0 21.3 12.4 21.3 21zM448 32v448h-448v-448h448zM151.3 287.8c0-21.2-12.1-34.5-46.7-44.8-20.6-7.4-26-10.9-26-18.6 0-7.7 7-14.6 20.4-14.6 14.1 0 20.8 8.5 20.8 18.3h30.7l0.2-0.6c0.5-19.6-15.1-41.7-51.1-41.7-23.4 0-52.5 10.8-52.5 38.3 0 19.4 9.3 31.3 50.7 44.4 17.3 6.2 21.9 10.4 21.9 19.5 0 15.2-19.1 14.2-19.5 14.2-20.4 0-25.6-9.1-25.6-21.9h-30.8l-0.2 0.6c-0.7 31.3 28.4 45.2 56.6 45.2 30 0 51.1-13.5 51.1-38.3zM276.7 232.2c0-25.3-18.4-45.5-53.4-45.5h-51.8v138.2h32.2v-47.4h19.6c30.3 0 53.4-16 53.4-45.4zM297.9 325l49.1-138.2h-31.1l-47.9 138.2h29.9zM404.5 186.8h-31.1l-47.9 138.2h29.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/stackpath.js
// module id = 1030
// module chunks = 0